import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {omit} from 'ramda';

import {TreeList as DXTreeList} from 'devextreme-react';


export default class TreeList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            expandedRowKeys: this.props.expandedRowKeys,
            defaultSelectedRowKeys: this.props.defaultSelectedRowKeys,
        };

        this.onRowCollapsing = this.onRowCollapsing.bind(this);
        this.onRowExpanding = this.onRowExpanding.bind(this);
        this.cellTemplate = this.cellTemplate.bind(this);
        this.headerCellTemplate = this.headerCellTemplate.bind(this);
        this._processCellTemplate = this._processCellTemplate.bind(this);

        this.onRowClick = this.onRowClick.bind(this);
        this.onRowDblClick = this.onRowDblClick.bind(this);
        this.onCellClick = this.onCellClick.bind(this);
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (this.state.defaultSelectedRowKeys !== props.defaultSelectedRowKeys) {
            this.setState({
                defaultSelectedRowKeys: props.defaultSelectedRowKeys,
            });
        }
    }

    onRowCollapsing(e) {
        const keys = this.state.expandedRowKeys;
        const targetIndex = keys.indexOf(e.key);
        this.setState({
            expandedRowKeys: [...keys.slice(0, targetIndex), ...keys.slice(targetIndex + 1)]
        })
    }

    onRowExpanding(e) {
        this.setState({
            expandedRowKeys: [...this.state.expandedRowKeys, e.key]
        })
    }

    cellTemplate(template_id) {
        var tmpl = window[template_id];
        return function(container, options) {
            ReactDOM.render(tmpl(options), container);
        }
    }

    headerCellTemplate(template_id) {
        var tmpl = window[template_id];
        return function(container, options) {
            ReactDOM.render(tmpl(options), container);
        }
    }

    _processCellTemplate(columns) {
        for(const c in columns){
            if (columns[c].cellTemplate && typeof columns[c].cellTemplate === 'string') {
                columns[c].cellTemplate = this.cellTemplate(columns[c].cellTemplate);
            }
            if (columns[c].headerCellTemplate && typeof columns[c].headerCellTemplate === 'string') {
                columns[c].headerCellTemplate = this.headerCellTemplate(columns[c].headerCellTemplate);
            }
            if (columns[c].columns && typeof columns[c].columns === 'object') {
                this._processCellTemplate(columns[c].columns);
            }
        }
    }

    onCellClick(e) {
        const {setProps} = this.props;

        // console.log('onCellClick', e)
        if (e.rowType === 'data' && setProps) {
            setProps({
                cellClick: {
                    rowType: e.rowType,
                    row: {
                        isEditing: e.row.isEditing,
                        isExpanded: e.row.isExpanded,
                        isSelected: e.row.isSelected,
                    },
                    rowIndex: e.rowIndex,
                    columnIndex: e.columnIndex,
                    dataField: e.column.dataField,
                    key: e.key,
                    text: e.text,
                    value: e.value,
                    timestamp: Date.now()
                }
            });
        }
    }

    onRowClick(e) {
        // console.log('onRowClick', e)

        const {setProps} = this.props;

        if (e.isSelected && setProps) {
            setProps({
                rowClick: {
                    data: e.data,
                    key: e.key,
                    handled: e.handled || false,
                    dataIndex: e.dataIndex,
                    isEditing: e.isEditing,
                    isExpanded: e.isExpanded,
                    isSelected: e.isSelected,
                    level: e.level,
                    rowIndex: e.rowIndex,
                    timestamp: Date.now()
                }
            });
        }
    }

    onRowDblClick(e) {
        // console.log('onRowDblClick', e)
        const {setProps} = this.props;

        if (setProps) {
            setProps({
                rowDblClick: {
                    data: e.data,
                    key: e.key,
                    timestamp: Date.now()
                }
            });
        }
    }

    render() {
        const { columns } = this.props;

        this._processCellTemplate(columns);

        return (
            <DXTreeList
                {...omit(['loading_state', 'setProps'], this.props)}
                columns={columns}
                defaultSelectedRowKeys={this.state.defaultSelectedRowKeys}
                expandedRowKeys={this.state.expandedRowKeys}

                onCellClick={this.props.onCellClick || this.onCellClick}
                onRowClick={this.props.onRowClick || this.onRowClick}
                onRowDblClick={this.props.onRowDblClick || this.onRowDblClick}

                onRowCollapsing={this.props.onRowCollapsing || this.onRowCollapsing}
                onRowExpanded={this.props.onRowExpanded || this.onRowExpanded}
                onRowExpanding={this.props.onRowExpanding || this.onRowExpanding}
            />
        );
    }
}

TreeList.propTypes = {
    /**
     * The ID used to identify this component in Dash callbacks
     */
    id: PropTypes.string,

    accessKey: PropTypes.string,
    activeStateEnabled: PropTypes.bool,
    allowColumnReordering: PropTypes.bool,
    allowColumnResizing: PropTypes.bool,
    autoExpandAll: PropTypes.bool,
    cacheEnabled: PropTypes.bool,
    /**
     * Dash event
     */
    cellClick: PropTypes.object,
    cellHintEnabled: PropTypes.bool,
    columnAutoWidth: PropTypes.bool,
    columnChooser: PropTypes.object,
    columnFixing: PropTypes.object,
    columnHidingEnabled: PropTypes.bool,
    columnMinWidth: PropTypes.number,
    columnResizingMode: PropTypes.oneOf(['nextColumn', 'widget']),
    columns: PropTypes.arrayOf(PropTypes.shape),
    columnWidth: PropTypes.number,
    customizeColumns: PropTypes.func,
    dataSource: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.object)]),
    dataStructure: PropTypes.oneOf(['plain', 'tree']),
    dateSerializationFormat: PropTypes.string,
    /**
     * Allows you to select rows or determine which rows are selected
     */
    defaultSelectedRowKeys: PropTypes.arrayOf(PropTypes.any),
    disabled: PropTypes.bool,
    editing: PropTypes.object,
    elementAttr: PropTypes.object,
    errorRowEnabled: PropTypes.bool,
    expandedRowKeys: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.number)]),
    expandNodesOnFiltering: PropTypes.bool,
    filterBuilder: PropTypes.object,
    filterBuilderPopup: PropTypes.object,
    filterPanel: PropTypes.object,
    filterRow: PropTypes.object,
    filterSyncEnabled: PropTypes.bool,
    filterValue: PropTypes.object,
    focusedColumnIndex: PropTypes.number,
    focusedRowEnabled: PropTypes.bool,
    focusedRowIndex: PropTypes.number,
    focusedRowKey: PropTypes.any,
    focusStateEnabled: PropTypes.bool,
    hasItemsExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    headerFilter: PropTypes.object,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.func]),
    highlightChanges: PropTypes.bool,
    hint: PropTypes.string,
    hoverStateEnabled: PropTypes.bool,
    itemsExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    keyExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    loadPanel: PropTypes.object,
    noDataText: PropTypes.string,
    onAdaptiveDetailRowPreparing: PropTypes.func,
    onCellClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    onCellHoverChanged: PropTypes.func,
    onCellPrepared: PropTypes.func,
    onContentReady: PropTypes.func,
    onContextMenuPreparing: PropTypes.func,
    onDataErrorOccurred: PropTypes.func,
    onDisposing: PropTypes.func,
    onEditingStart: PropTypes.func,
    onEditorPrepared: PropTypes.func,
    onEditorPreparing: PropTypes.func,
    onFocusedCellChanged: PropTypes.func,
    onFocusedCellChanging: PropTypes.func,
    onFocusedRowChanged: PropTypes.func,
    onFocusedRowChanging: PropTypes.func,
    onInitialized: PropTypes.func,
    onInitNewRow: PropTypes.func,
    onKeyDown: PropTypes.func,
    onNodesInitialized: PropTypes.func,
    onOptionChanged: PropTypes.func,
    onRowClick: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    onRowCollapsed: PropTypes.func,
    onRowCollapsing: PropTypes.func,
    onRowExpanded: PropTypes.func,
    onRowExpanding: PropTypes.func,
    onRowInserted: PropTypes.func,
    onRowInserting: PropTypes.func,
    onRowPrepared: PropTypes.func,
    onRowRemoved: PropTypes.func,
    onRowRemoving: PropTypes.func,
    onRowUpdated: PropTypes.func,
    onRowUpdating: PropTypes.func,
    onRowValidating: PropTypes.func,
    onSelectionChanged: PropTypes.func,
    onToolbarPreparing: PropTypes.func,
    pager: PropTypes.object,
    paging: PropTypes.object,
    parentIdExpr: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    remoteOperations: PropTypes.object,
    renderAsync: PropTypes.bool,
    repaintChangesOnly: PropTypes.bool,
    rootValue: PropTypes.any,
    rowAlternationEnabled: PropTypes.bool,
    /**
     * Dash event
     */
    rowClick: PropTypes.object,
    /**
     * Dash event
     */
    rowDblClick: PropTypes.object,
    /**
     * Dash event
     */
    rtlEnabled: PropTypes.bool,
    scrolling: PropTypes.object,
    searchPanel: PropTypes.object,
    selectedRowKeys: PropTypes.arrayOf(PropTypes.any),
    selection: PropTypes.object,
    showBorders: PropTypes.bool,
    showColumnHeaders: PropTypes.bool,
    showColumnLines: PropTypes.bool,
    showRowLines: PropTypes.bool,
    sorting: PropTypes.object,
    stateStoring: PropTypes.object,
    tabIndex: PropTypes.number,
    twoWayBindingEnabled: PropTypes.bool,
    visible: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.func]),
    wordWrapEnabled: PropTypes.bool,

    /**
     * Dash-assigned callback that gets fired when the value changes.
     */
    setProps: PropTypes.func
};

TreeList.defaultProps = {
    accessKey: null,
    activeStateEnabled: false,
    allowColumnReordering: false,
    allowColumnResizing: false,
    autoExpandAll: false,
    cacheEnabled: true,
    cellHintEnabled: true,
    columnAutoWidth: false,
    // columnChooser
    // columnFixing
    columnHidingEnabled: false,
    columnMinWidth: undefined,
    columnResizingMode: 'nextColumn',
    columns: undefined,
    columnWidth: undefined,
    // customizeColumns
    dataSource: null,
    dataStructure: 'plain',
    // dateSerializationFormat
    defaultSelectedRowKeys: [],
    disabled: false,
    // editing
    elementAttr: {},
    errorRowEnabled: true,
    expandedRowKeys: [],
    expandNodesOnFiltering: true,
    filterBuilder: {},
    filterBuilderPopup: {},
    filterPanel: {},
    // filterRow
    // filterSyncEnabled
    filterValue: null,
    focusedColumnIndex: -1,
    focusedRowEnabled: false,
    focusedRowIndex: -1,
    focusedRowKey: undefined,
    focusStateEnabled: false,
    // hasItemsExpr
    // headerFilter
    height: undefined,
    highlightChanges: false,
    hint: undefined,
    hoverStateEnabled: false,
    itemsExpr: 'items',
    keyExpr: 'id',
    // loadPanel
    noDataText: 'No data',
    onAdaptiveDetailRowPreparing: null,
    onCellClick: null,
    onCellHoverChanged: null,
    onCellPrepared: null,
    onContentReady: null,
    onContextMenuPreparing: null,
    onDataErrorOccurred: null,
    onDisposing: null,
    onEditingStart: null,
    onEditorPrepared: null,
    onEditorPreparing: null,
    onFocusedCellChanged: null,
    onFocusedCellChanging: null,
    onFocusedRowChanged: null,
    onFocusedRowChanging: null,
    onInitialized: null,
    onInitNewRow: null,
    onKeyDown: null,
    onNodesInitialized: null,
    onOptionChanged: null,
    onRowClick: null,
    onRowCollapsed: null,
    onRowCollapsing: null,
    onRowExpanded: null,
    onRowExpanding: null,
    onRowInserted: null,
    onRowInserting: null,
    onRowPrepared: null,
    onRowRemoved: null,
    onRowRemoving: null,
    onRowUpdated: null,
    onRowUpdating: null,
    onRowValidating: null,
    onSelectionChanged: null,
    onToolbarPreparing: null,
    // pager
    // paging
    parentIdExpr: 'parentId',
    // remoteOperations
    renderAsync: false,
    repaintChangesOnly: false,
    rootValue: 0,
    rowAlternationEnabled: false,
    rtlEnabled: false,
    // scrolling
    // searchPanel
    // selectedRowKeys
    // selection
    showBorders: false,
    showColumnHeaders: true,
    showColumnLines: true, // false (Material)
    showRowLines: false, // true (iOS, Material)
    // sorting
    // stateStoring
    tabIndex: 0,
    twoWayBindingEnabled: true,
    visible: true,
    width: undefined,
    wordWrapEnabled: false
};
